import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "@environments/environment";
import {combineLatest, Observable, throwError, of} from "rxjs";
import {distinctUntilChanged, map, retry, tap, catchError, delay, take} from "rxjs/operators"; //retryWhen, switchMap,
import {UserService} from "@services/user/user.service";
import {appRoutingEnum} from "@enums/appRoutingEnum";

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  public url: any;
  public all_header: any;
  private file_transferHeader: any;
  public headerLogin: any;

  get header() {
    return this.all_header;
  }

  get fileTransferHeaders() {
    return this.file_transferHeader;
  }

  constructor(
    public http: HttpClient,
    public user: UserService,
  ) {
    this.url = environment.baseUrl + environment.api;
    combineLatest(
      [this.user.getUserData().pipe(distinctUntilChanged())])
      .pipe(
        map(([data]): any => {
          if(data) {
            const username = data ? data.username : '';
            const password = data ? data.password : '';
            const bash = data ? data.bash : '';
            if (typeof data.app != 'undefined' && (data.app == 'login' || data.app == 'not_activate')) {

            } else if ((typeof data.app != 'undefined' && data.app == 'renew') || (typeof data.status != 'undefined' && data.status == 'renew')) {
              //this.setOneTimeHeader(username, password);
              this.userLogin();
              //return this.all_header;
            } else {
              //return this.all_header;
            }
            return this.setOneTimeHeader(username, password, bash);
          }else{
            return this.all_header;
          }
        }),
        tap(header => this.all_header = header)/*,
        map((header): HttpOptions => {
          let myHeaders = header.headers;
          myHeaders = myHeaders.append('enctype', 'multipart/form-data');
          return {
            headers: myHeaders,
            observe: 'body'
          };
        }),
        tap(header => this._fileTransferHeader = header)*/
      )
      .subscribe();
  }

  userLogin(){
    this.post(this.url + '/login','',this.headerLogin).subscribe((res: any) => {
      if(res && typeof res.bash != 'undefined') {
        this.setOneTimeHeader('', '', res.bash);
        this.user.storage.setItem('userData', res).then();
      }
      //this.api.data['current'] = res;
    });
  }

  setOneTimeHeader(username = '', password = '', bash = '') {
    let myHeaders = new HttpHeaders();
    myHeaders = myHeaders.append('Content-type', 'application/json');
    myHeaders = myHeaders.append('Accept', '*/*');
    if (password !== '' && username !== '') {
      let loginHeaders = new HttpHeaders();
      loginHeaders = loginHeaders.append('Content-type', 'application/json');
      loginHeaders = loginHeaders.append('Accept', '*/*');
      loginHeaders = loginHeaders.append("Base", btoa(encodeURIComponent(username) + '523' + encodeURIComponent(password)));
      this.headerLogin = {
        headers: loginHeaders,
        observe: 'body'
      };
    }
    let transferHeaders = new HttpHeaders();
    transferHeaders = transferHeaders.append('Accept', '*/*');
    if(bash !== ''){
      myHeaders = myHeaders.append("Bash", bash);
      transferHeaders = transferHeaders.append("Bash", bash);
      this.all_header = {
        headers: myHeaders,
        observe: 'body'
      };
    }
    this.file_transferHeader = {
      headers: transferHeaders,
      observe: 'body'
    };
    return {
      headers: myHeaders,
      observe: 'body'
    };
  }

  // post(url: string, data: {}, headers: any = this.all_header) {
  //   return this.http.post(url, data, headers).pipe(retry(3));
  // }

  post(url: string, data: {}, headers: any = this.all_header) {
    return this.http.post(url, data, headers).pipe(
      delay(500),
      retry(3),
      catchError(err => {
        if(typeof err.error != 'undefined' && err.error.status == 'renew') {
            this.userLogin();
            return this.http.post(url, data, this.all_header);
        }
        console.log('Initial post request failed, retrying with new headers...');
        return throwError(() => err);
      })//,
      // retryWhen(errors =>
      //   errors.pipe(
      //     take(1), // Only one retry
      //     delay(500), // Wait before retry
      //     switchMap(() => {
      //       const newHeaders = this.all_header;
      //       return this.http.post(url, data, newHeaders); // Retry manually
      //     })
      //   )
      // )
    );
  }

  get(url: string, headers: any = this.all_header) {
    return this.http.get(url, headers).pipe(
      delay(500),
      retry(3),
      catchError(err => {
        if(typeof err.error != 'undefined' && err.error.status == 'renew') {
          this.userLogin();
          return this.http.get(url, this.all_header);
        }
        console.log('Initial get request failed, retrying with new headers...');
        return throwError(() => err);
      }));//.pipe(retry(3));
  }
}

// export interface HttpOptions {
//   headers: HttpHeaders,
//   observe: 'body'
// }
